import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * UI range DatePicker ↔ listQuery.filters（API：`return_date_from`／`return_date_to`）。
 */
export function readReturnDateRangeFilter(filters = {}) {
  const from = filters.returnDateFrom;
  const to = filters.returnDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyReturnDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.returnDateFrom;
    delete next.returnDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.returnDateFrom = from || undefined;
  next.returnDateTo = to || undefined;

  return next;
}

export function resolveReturnDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.returnDateFrom,
    to: ctx.filters?.returnDateTo,
  });

  return display ? [display] : [];
}
